import { Component, inject } from '@angular/core';
import { SigtChargementEnCoursService } from 'src/app/integration/sigt-chargement-en-cours/sigt-chargement-en-cours.service';
import { ZzzConfigService } from 'src/app/zzz/core/config/config.service';
import { ZzzSecuriteService } from 'src/app/zzz/securite/shared/securite.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-accueil-non-authentifie',
    templateUrl: './accueil-non-authentifie.component.html',
    styleUrls: ['./accueil-non-authentifie.component.scss'],
    imports: [
        TranslateModule
    ]
})
export class AccueilNonAuthentifieComponent {
  #chargementEnCoursService = inject(SigtChargementEnCoursService);
  #configService = inject(ZzzConfigService);
  #securiteService = inject(ZzzSecuriteService);

  urlInscription = this.#configService.get().lienProfilUtilisateurDansIDZ + "/inscription?appcode=SIGT";

  onClickConnexion() {
    this.#chargementEnCoursService.afficher(true);
    this.#securiteService.redirectToProvider().subscribe();
  }
}
